export const EXCMCONSENT_DELETE_RESET = 'EXCMCONSENT_DELETE_RESET'
export const EXCMCONSENT_DELETE_SET_ERROR = 'EXCMCONSENT_DELETE_SET_ERROR'
export const EXCMCONSENT_DELETE_SET_DELETED = 'EXCMCONSENT_DELETE_SET_DELETED'
export const EXCMCONSENT_DELETE_TOGGLE_LOADING = 'EXCMCONSENT_DELETE_TOGGLE_LOADING'
